import { render, staticRenderFns } from "./ModalCadastroItinerarioFormativo.vue?vue&type=template&id=0842d92e"
import script from "./ModalCadastroItinerarioFormativo.vue?vue&type=script&lang=js"
export * from "./ModalCadastroItinerarioFormativo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports